import { mapKeys } from 'lodash-es'

export const WEBSITE_NOT_FOUND = 'WebsiteNotFound'
export const BROKEN_SCRAPING_INSTRUCTIONS = 'BrokenScrapingInstructions'
export const INTERNAL_SERVER_ERROR = 'InternalServerError'
export const SCRAPING_TIMEOUT_REACHED = 'ScrapingTimeoutReached'
export const NO_DISHES_SCRAPED = 'NoDishesScraped'
export const STATE_RESTORATION_FAILED = 'StateRestorationFailed'
export const DUPLICATE_CONTENT = 'DuplicateContent'

export const SCRAPING_RESPONSE_ERROR_CODES = mapKeys(
  [
    { name: 'Website not responding', value: WEBSITE_NOT_FOUND },
    {
      name: 'Broken scraping instructions',
      value: BROKEN_SCRAPING_INSTRUCTIONS,
    },
    { name: 'Internal server error', value: INTERNAL_SERVER_ERROR },
    { name: 'Scraping timeout reached', value: SCRAPING_TIMEOUT_REACHED },
    { name: 'No dishes scraped', value: NO_DISHES_SCRAPED },
    { name: 'State restoration failed', value: STATE_RESTORATION_FAILED },
    { name: 'Duplicate content', value: DUPLICATE_CONTENT },
  ],
  'value',
)
